import React from "react";
import { Form, Col, Container, Row } from "react-bootstrap";

const statusOptions = [
  { value: "", label: "-- Wszystkie --" },
  { value: "-1", label: "Do akceptacji" },
  { value: "0", label: "Nowy" },
  { value: "1", label: "W trakcie wykonywania" },
  { value: "2", label: "Zakończony" },
  { value: "4", label: "Przerwany - Błąd" },
  { value: "5", label: "Odrzucony" },
  { value: "6", label: "Zaplanowany" },
  { value: "7", label: "Wycofany" },
  { value: "8", label: "W trakcie wycofywania" },
  { value: "9", label: "Wycofanie nieudane" },
];

const actionOptions = [
  { value: "", label: "-- Wszystkie --" },
  { value: "0", label: "Masowa aktualizacja" },
  { value: "3", label: "Import CSV" },
  { value: "4", label: "Import SHP" },
];

const DataImportFilters = ({ onFilterChange, onSearch, onImmediateFilterChange, filters = {}, isSuperUser = false }) => {
  const visibleActionOptions = isSuperUser
    ? actionOptions
    : actionOptions.filter((opt) => opt.value !== "3");

  return (
    <Container className="mt-4">
      <Form onKeyDown={(e) => { if (e.key === 'Enter' && !['TEXTAREA', 'SELECT'].includes(e.target.tagName)) { e.preventDefault(); onSearch?.(); } }}>
        <Row className="mb-3">
          <Col md={2}>
            <Form.Group controlId="dateStartFrom">
              <Form.Label>Data rozpoczęcia od</Form.Label>
              <Form.Control
                type="date"
                value={filters.dateStartFrom || ""}
                onChange={(e) => onFilterChange("dateStartFrom", e.target.value)}
              />
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group controlId="dateStartTo">
              <Form.Label>Data rozpoczęcia do</Form.Label>
              <Form.Control
                type="date"
                value={filters.dateStartTo || ""}
                onChange={(e) => onFilterChange("dateStartTo", e.target.value)}
              />
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group controlId="rollbackDateFrom">
              <Form.Label>Data wycofania od</Form.Label>
              <Form.Control
                type="date"
                value={filters.rollbackDateFrom || ""}
                onChange={(e) => onFilterChange("rollbackDateFrom", e.target.value)}
              />
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group controlId="rollbackDateTo">
              <Form.Label>Data wycofania do</Form.Label>
              <Form.Control
                type="date"
                value={filters.rollbackDateTo || ""}
                onChange={(e) => onFilterChange("rollbackDateTo", e.target.value)}
              />
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group controlId="status">
              <Form.Label>Status</Form.Label>
              <Form.Select
                value={filters.status ?? ""}
                onChange={(e) => (onImmediateFilterChange || onFilterChange)("status", e.target.value)}
              >
                {statusOptions.map((opt) => (
                  <option key={opt.value} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group controlId="action">
              <Form.Label>Rodzaj</Form.Label>
              <Form.Select
                value={filters.action ?? ""}
                onChange={(e) => (onImmediateFilterChange || onFilterChange)("action", e.target.value)}
              >
                {visibleActionOptions.map((opt) => (
                  <option key={opt.value} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </Col>
        </Row>
        <Row className="mb-3">
          <Col md={3}>
            <Form.Group controlId="fileName">
              <Form.Label>Plik</Form.Label>
              <Form.Control
                type="text"
                placeholder="Nazwa pliku..."
                value={filters.fileName || ""}
                onChange={(e) => onFilterChange("fileName", e.target.value)}
              />
            </Form.Group>
          </Col>
        </Row>
      </Form>
    </Container>
  );
};

export default DataImportFilters;
